import React from "react";
import { useState, useEffect } from "react";

import Select, { components } from "react-select";
import { useSelector, useDispatch } from "react-redux";

import {
  fetchIntegrations,
  fetchIntegrationContacts,
  invalidateIntegrationContacts,
} from "src/legacy/redux/actions/integrations.jsx";
import { searchContactForAutoComplete } from "src/legacy/redux/actions/search.jsx";
import IntegrationsService from 'src/legacy/services/integrations.service.jsx';

import { createContact } from "src/legacy/redux/actions/rolodex";
import EmailTagView from "./values";
import EmailOptionView from "./options";

import styles from "./Styles.module.scss";
import cx from "classnames";
import { localizedStrings } from 'src/localization';
import _ from "lodash";


export default function EmailAutoCompleteView(props) {
  const [options, setOptions] = useState([]);
  const [query, setQuery] = useState("");
  const [selectedGroup, setSelectedGroup] = useState("");
  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [placeholder, setPlaceholder] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const localizedCommons = localizedStrings.commons;

  const contacts = useSelector((state) => state.legacyRootReducer.search.contacts.items);
  const allIntegrations = useSelector((state) =>
    _.get(state.legacyRootReducer, "settings.integrations.activated.items")
  );

  const getIntegrations = () => {
    const integrationsList = IntegrationsService.getIntegrations(localizedStrings.components.integrations.integrations);
    return integrationsList.integrations;
  }


  const integrations = allIntegrations
    .filter((item) => {
      const category = _.get(item, "category.id");

      if (category != "crm") {
        return false;
      }

      const masterData = getIntegrations().find((data) => {
        return data.type === item.type;
      });

      return masterData && masterData.searchContacts;
    })
    .map((item) => {
      const masterData = getIntegrations().find((data) => {
        return data.type === item.type;
      });

      return {
        ...item,
        masterData: masterData,
      };
    });

  const integrationSearchResult = useSelector(
    (state) => state.legacyRootReducer.rolodex.integrations
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchIntegrations());
    if (!_.isEqual(props.placeholder, placeholder)) {
      setPlaceholder(props.placeholder);
    }
  }, []);
  useEffect(() => {
    if(props.clearValue === true){
      setTags([]);
    }
  }, [_.get(props,"clearValue",false)]);

  useEffect(() => {
    const validOptions = populateOptions();

    if (!_.isEqual(options, validOptions)) {
      setOptions(validOptions);
    }
    setIsLoading(false);
  }, [contacts]);


  useEffect(() => {
    var groupName =  (window.localStorage.getItem('crm')) ? window.localStorage.getItem('crm') : "Paperflite";
    setSelectedGroup(groupName);
    
    var group = integrations.filter((integration) => _.get(integration, 'masterData.name') == groupName)

    if(_.isEmpty(group)){
      setSelectedGroup("Paperflite") 
    }

    var newOptions = populateOptions();
    if (!_.isEqual(options, newOptions)) {
      setOptions(newOptions);
      setIsLoading(false);
    }

  }, [integrations]);

  useEffect(() => {
    if (props.onInputChange) {
      props.onInputChange(query, tags);
    }
    if (props.onChange) {
      props.onChange(tags);
    }
  }, [tags]);

  const processContacts = (contacts) => {
    if (_.size(contacts) === 0) {
      return [];
    }

    return contacts
      .filter((contact) => {
        if (tags) {
          var index = tags.findIndex((tag) => {
            if (tag.type == "contact") {
              return tag.value.id == contact.id;
            } else if (tag.type == "email") {
              return tag.value == contact.email;
            }
          });
          return index == -1;
        }
        return true;
      })
      .map((contact, index) => {
        return {
          value: contact,
          label:
            contact.entityType == "contact"
              ? `${contact.firstName ? contact.firstName : ""} ${
                  contact.lastName ? contact.lastName : ""
                }`
              : contact.name,
          type: contact.entityType,
          valid: true,
          name: "Paperflite",
          isFocused: index == 0 ? true : false
        };
      });
  };

  const populateOptions = () => {
    if (!query || query == "") {
      return [];
    }

    const hasIntegrations = _.size(integrations) > 0;

    if (!hasIntegrations) {
      return processContacts(contacts);
    }

    var options = processContacts(contacts);

    var groups = [
      {
        type: "option_group",
        label: "Paperflite",
        source: "paperflite",
        options: options,
        selected: selectedGroup === "paperflite",
      },
    ];

    integrations.forEach((integration) => {
      var integrationOption = {
        type: "option_group",
        label: integration.masterData.name,
        source: integration.masterData.type,
        integration: integration,
        selected: selectedGroup === integration.masterData.type,
        options: [
          {
            type: "option_group",
            label: "empty",
            fetching: true,
            fetched: false,
            empty: false,
            value: "Searching",
            name: integration.masterData.type,
          },
        ],
      };
      if (integrationSearchResult.id === integration.id) {
        const searching = integrationSearchResult.searching;
        const items = integrationSearchResult.items;
        const fetched = integrationSearchResult.fetched;
        if (fetched) {
          var options = processContacts(items);
          if (options.length == 0) {
            options = [
              {
                type: "option_group",
                label: "empty",
                fetching: searching,
                fetched: fetched,
                empty: true,
                value: "No results found",
                name: integration.masterData.type,
              },
            ];
          }
          integrationOption = {
            ...integrationOption,
            options: options,
          };
        }
      }
      groups = [...groups, integrationOption];
    });

    return groups;
  };

  const handleInputChange = (inputValue) => {
    var query = inputValue.trim();

    if (query.length <= 1) {
      setQuery("");
      setMenuIsOpen(false);
    } else {
      setQuery(query);
      var group = options.filter((option) => option.label == selectedGroup)

      if(selectedGroup === "Paperflite"){
        dispatch(invalidateIntegrationContacts());
        dispatch(searchContactForAutoComplete(query, props.entityType));
      } else if(!_.isEmpty(group[0], 'integration.id')){
        dispatch(fetchIntegrationContacts(group[0].integration.id, query, 0)).then(
          populateOptions()
        );
      }
    
      setIsLoading(true);
      if (_.size(query) > 2 && !menuIsOpen) {
        setMenuIsOpen(true);
      }
    }

    if (props.onInputChange) {
      props.onInputChange(query, tags);
    }

    return inputValue;
  };

  const handleCreateTag = (newTag) => {
    if (!Array.isArray(newTag)) {
      newTag = [newTag];
    }

    const newTags = _.differenceWith(newTag, tags);
    if (newTags) {
      newTags
        .filter((option) => {
          const source = _.get(option, "group.source") || "paperflite";
          return source !== "paperflite";
        })
        .forEach((option) => {
          var request = {
            email: _.get(option, "value.email"),
            firstName: _.get(option, "value.firstName"),
            lastName: _.get(option, "value.lastName"),
            company: _.get(option, "value.company"),
            workPhone: _.get(option, "value.workPhone"),
            sources: [
              {
                type: _.get(option, "value.sources[0]"),
              },
            ],
          };

          if (!_.isNull(props.contactSource)) {
            request = {
              ...request,
              sources: [...request.sources, { type: props.contactSource }],
            };
          }

          props.createContact(request);
        });
    }

    setTags((prevTags) => [...prevTags, ...newTags]);
    setInputValue("");
    setMenuIsOpen(false);
    setIsLoading(false);
    if (props.onChange) {
      props.onChange([...tags, ...newTags]);
    }
  };

  const handleGroupSelection = (group) => {
    var selectedGroup  = _.get(group, "masterData.name", "Paperflite");
    setSelectedGroup(selectedGroup);
    window.localStorage.setItem('crm',selectedGroup)
    dispatch(fetchIntegrationContacts(group.id, query, 0)).then(
      populateOptions()
    );
  
  };

  const isValidEmail = (email) => {
    if (!email) {
      return false;
    }

    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const handleCreateNewOption = (value) => {
    var pattern = ",|;|'";

    var regex = new RegExp(pattern);
    var email = value.split(regex).join("");

    var newTag = {
      label: email,
      value: email,
      valid: true,
      type: "email",
    };

    handleCreateTag(newTag);
  };

  const shouldKeyDownEventCreateNewOption = (e) => {
    var keyCode = e.keyCode;
    switch (keyCode) {
      case 13: // ENTER
        let value = e.target.value.trim();
        value = value.replace(/[.,;:\s]+$/, "");
        const isValid = isValidEmail(value);
        if(isValid){
          handleCreateNewOption(value);
        }
        break;
      case 8: //BACKSPACE
        if (tags.length > 0 && e.target.value == 0) {
          const allTags = [...tags];
          const selectedTags = allTags.slice(0, allTags.length - 1);
          setTags(selectedTags);
        }
        break;
    }
  };


  const handleBlur = (e) => {

    const value = e.target.value;
    const inputValues = value.split(/[,\s;]+/);
    
    inputValues.forEach(inputValue => {
      if (inputValue) {

        var pattern = ",|;|'";
  
        var regex = new RegExp(pattern);
        var label = inputValue.split(regex).join("");
        var value = inputValue.replace(/[<>]/g, '')

        if (isValidEmail(value)) {
          var newTag = {
            label: label,
            value: value,
            valid: true,
            type: "email",
          };
      
          handleCreateTag(newTag);
  
        }
    
      }
      setMenuIsOpen(false);
      setIsLoading(false);
    })

    if (_.size(query) == 0 && props.placeholder) {
      setPlaceholder(props.placeholder);
    }
  };

  const onNewOptionClick = (option) => {

    var newTag = {
      label: option.name,
      value: option,
      valid: true,
      type: option.entityType,
    };

    if(canCreateContact(option)){
      createContactForRequest(option);
    }
    handleCreateTag(newTag);
  };
  const canCreateContact = (option) => {
    return _.get(option, "sources[0]", false);
  }
  const createContactForRequest = (option) => {
   
    var request = {
      email: _.get(option, "email"),
      firstName: _.get(option, "firstName"),
      lastName: _.get(option, "lastName"),
      sources: [
        {
          type: _.get(option, "sources[0]"),
        },
      ],
    };

    dispatch(createContact(request));

  }
  const onRemove = (value) => {
    const selectedTags = tags.filter(
      (tag) => tag.value.id != value.id || tag.value != value
    );

    setTags(selectedTags);
    props.onChange(selectedTags);
  };

  const getStyles = () => {
    return {
      control: (provided, state) => ({
        ...provided,
        padding : "0.25rem 0rem",
        border: state.isFocused ? 0 : 0,
        boxShadow: state.isFocused ? 0 : 0,
        fontSize: "12px",
        backgroundColor: "$secondary-background-color",
        maxHeight: "6.5rem",
        overflow: "scroll",
        caretColor: _.get(props,"contactSource") === "generate_link" && _.size(tags)>0 ? "transparent" : "auto", 
        '::-webkit-scrollbar': {
          display: 'none !important', 
        },
      }),
      input: (provided) => ({
        ...provided,
        padding: 0,
      }),
      valueContainer: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
        backgroundColor: "$secondary-background-color",
      }),
      placeholder: (base) => ({
        ...base,
        fontSize: "12px",
      }),
      indicatorSeparator: (base, state) => ({
        ...base,
        alignSelf: "auto",
      }),
      dropdownIndicator: (base, state) => ({
        ...base,
        display: "none",
      }),
      singleValue: (base, state) => ({
        ...base,
        
        backgroundColor: "$secondary-background-color",
      }),
      multiValue: (base, state) => ({
        ...base,
        backgroundColor: "$secondary-background-color",
      }),
      multiValueRemove: (base, { data }) => ({
        ...base,
        display: "none",
      }),
      menuList: (base) => ({
        ...base,
        height: "100%",
        minHeight: "4rem",
        maxHeight: "12rem",
        margin: 0,
        padding: 0,
        borderRadius: 10,
        '::-webkit-scrollbar': {
          display: 'none !important', 
        },
        backgroundColor: "$secondary-background-color",
        "& > :nth-child(2) > :first-child": {
          padding: 0, 
        },
      }),
      menu: (base) => ({
        ...base,
        width: props.contactSource === "quicksend" ? "120%" : "110%",
        margin: 0,
        padding: 0,
        backgroundColor: "$secondary-background-color",
        fontSize: "14px",
        borderRadius: 10,
        marginTop: 10,
        marginLeft: props.contactSource === "quicksend" ? -20 : -10,
      }),
      option: (base) => ({
        ...base,
        margin: '0 !important',
        padding: '0 !important',
      })
    };
  };

  const PlaceholderMessage = () => {
    return <div className={styles.placeholderMessage}>{localizedCommons.contacts_search.no_contacts_found}</div>;
  };

  const MenuOptions = ({ children, integrations, onTabChange, selectedGroup, ...rest }) => {
    const [showIntegrations, setShowIntegrations] = useState(false);

    if (_.size(integrations) > 0 && !showIntegrations) {
      setShowIntegrations(true);
    }

    return (
      <components.MenuList {...rest}>
        <div className={styles.menuList}>
          <div>
            {showIntegrations && (
              <div className={styles.groupHeading}>
                <span className={styles.menuListTitle}>{localizedCommons.contacts_search.search_within}:</span>
                <div
                  className={cx("menu-header", styles.tab, {
                    [styles.activeTab]: selectedGroup === "Paperflite",
                  })}
                  onClick={ () =>{
                    onTabChange("Paperflite")}}
                >
                  Paperflite
                </div>
                {integrations.map((integration) => {
                  return (
                    <button
                      key={integration.type}
                      className={cx(styles.tab, {
                        [styles.activeTab]:
                          selectedGroup === integration.masterData.name,
                      })}
                      onClick={() => onTabChange(integration)}
                    >
                      {integration.masterData.name}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        <div className={styles.children}>
        {children}
        </div>
      </components.MenuList>
    );
  };

  return (
    <div
      className={cx(styles.emailContainer, {
        [styles.emailContainerAdjusted]: props.contactSource === "quicksend",
      })}
    >
      <Select
        isCreatable
        menuIsOpen={menuIsOpen}
        isClearable={false}
        isMulti={props.contactSource === "quicksend" ? true : false}
        placeholder={placeholder}
        isLoading={isLoading}
        loadingMessage={() => `${localizedCommons.loading.loading}...`}
        options={
          _.size(integrations) > 0
            ? options.filter((option) => option.label == selectedGroup)
            : options
        }
        filterOption={(option, input) => {
          return option;
        }}
        inputValue={inputValue}
        value={tags ? tags : ""}
        styles={getStyles()}
        onKeyDown={shouldKeyDownEventCreateNewOption}
        components={{
          Option: ({ data }) => {
            return (
              <EmailOptionView
                option={data}
                key={data.label}
                setValue={onNewOptionClick}
              />
            );
          },
          MenuList: (props, option) => (
            <div className={styles.menuListOptions}>
              <MenuOptions
                {...props}
                option={option}
                integrations={integrations}
                selectedGroup={selectedGroup}
                onTabChange={(group) => handleGroupSelection(group)}
              />
            </div>
          ),
          GroupHeading: () => null,
          NoOptionsMessage: () => <PlaceholderMessage></PlaceholderMessage>,
        }}
        onInputChange={(value, action) => {
          handleInputChange(value);
          if (action.action == "input-change" && !props.isInputValid) {
            setInputValue(value);
          }
        }}
        formatOptionLabel={(option) => (
          <EmailTagView
            hideRemoveIcon={_.get(props, "hideRemoveIcon", false)}
            option={option}
            onRemove={onRemove}
            {...props}
          />
        )}
        onBlur={handleBlur}
      />
    </div>
  );
}
